var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.success)?_c('div',[_c('h3',[_vm._v("You successfully Logged out.")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }